import { Heading, Icon, Text, VStack } from '@chakra-ui/react';
import { LuBadgeCheck } from 'react-icons/lu';

const EmptySuccessState = () => {
  return (
    <VStack
      w="100%"
      py={12}
      px={6}
      gap={1}
      justify="center"
      textAlign="center"
      border="1px solid"
      borderColor="gray.200"
      borderRadius={4}
      p={3}
    >
      <Icon as={LuBadgeCheck} boxSize={8} color="green.700" />
      <Heading fontSize={18} fontWeight={600} color="gray.700">
        The agent completed successfully
      </Heading>
      <Text color="fg.muted" fontSize={14} fontWeight={400}>
        Everything ran as expected and no issues were detected
      </Text>
    </VStack>
  );
};

export default EmptySuccessState;
